import { render } from "./CrudRntrcSolicitacao.vue?vue&type=template&id=156e257f&scoped=true"
import script from "./CrudRntrcSolicitacao.vue?vue&type=script&lang=ts"
export * from "./CrudRntrcSolicitacao.vue?vue&type=script&lang=ts"

import "./CrudRntrcSolicitacao.vue?vue&type=style&index=0&id=156e257f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-156e257f"

export default script